$(document).ready(function () {

    // Rtl Scripts Important
    var _rtl = false;
    if ($("body").css('direction') == 'rtl') {
        _rtl = true;
    }

    // navbar li active
    $('.navbar-nav li a').click(function () {
        $(this).parent().addClass('active').siblings().removeClass('active');
    });

    // Add sticky navTop
    if (($(window).width()) > 992) {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 300) {
                $('.top-head').addClass('stick');
            } else {
                $('.top-head').removeClass('stick');
            }
        });
    }

    if (($(window).width()) < 992) {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 300) {
                $('.top-head').addClass('fixed-icon');
            } else {
                $('.top-head').removeClass('fixed-icon');
            }
        });
    }

    // show navbar collapse from Right
    $('.navbar .toggler').on('click', function () {
        $('.navbar .navbar-collapse').animate({
            right: 0
        }, 100).css({'box-shadow': '-7px 0px 30px rgba(0,0,0,0.4)'});
    });

    // Hide Side Navbar When Click Outside
    $(document).on("click", function (event) {
        var $trigger = $('.navbar ');
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
            $('.navbar .navbar-collapse').animate({
                right: '-250px'
            }, 100).css('box-shadow', 'none')
        }
    });

    // hide side navbar when click icon close
    $('.navbar .navbar-collapse .close-nav').on('click', function () {
        $('.navbar .navbar-collapse').animate({
            right: '-250px'
        }, 100).css('box-shadow', 'none');
    });

    $('.home-project-carousel').owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        rtl: _rtl,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
        navClass: ['owl-prev', 'owl-next'],
        responsive: {
            0: {
                autoWidth: true,
                margin: 10,
            },
            992: {
                items: 2,
                center: true,
                margin: 10,
            },
            1200: {
                items: 3,
                center: true,
                margin: 15,
            }
        },
    })

    $('.blog-carousel').owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        rtl: _rtl,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
        navClass: ['owl-prev', 'owl-next'],
        items: 2,
        responsive: {
            768: {
                margin: 10,
            },
            992: {
                margin: 15,
            }
        },
    })

    $('.mobile-blog-carousel').owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        rtl: _rtl,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
        navClass: ['owl-prev', 'owl-next'],
        autoWidth: true,
        margin: 10,
    })

    $('.statistics-carousel').owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        rtl: _rtl,
        items: 2,
        responsive: {
            0: {
                margin: 0,
                items: 1,
            },
            992: {
                margin: 15,
            }
        },
    })

    $('.project-carousel').owlCarousel({
        loop: false,
        margin: 10,
        nav: true,
        dots: false,
        rewind: true,
        rtl: _rtl,
        items: 1,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
        navClass: ['owl-prev', 'owl-next'],

    }).on("changed.owl.carousel", function (e) {
            $(".images-thumbs").trigger("to.owl.carousel", [e.item.index, 200, !0]);
        }
    );

    $('.images-thumbs').owlCarousel({
        loop: false,
        margin: 15,
        nav: true,
        dots: false,
        center: false,
        rewind: true,
        rtl: _rtl,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
        navClass: ['owl-prev', 'owl-next'],
        items: 4,
        responsive: {
            0: {
                margin: 5,
            },
            992: {
                margin: 15,
            }
        },

    }).on("click", ".owl-item .item", function (e) {
            e.preventDefault(), $(".project-carousel").trigger("to.owl.carousel", [$(this).parent().index('.owl-item'), 200, !0])
        }
    );

    // Contact Form Label seller or buyer
    $('.form-check-label').click(function () {
        $(this).addClass('active').parent().siblings().children().removeClass('active');
    });

    $('#seller-option').click(function () {
        $('.business-info').css('opacity', '1');
    })

    $('#buyer-option').click(function () {
        $('.business-info').css('opacity', '0');
    })

    // for project modal in home page when click on the image of project
    $('.project-modal').click(function () {
        $('.project-modal').removeClass('active');
        $(this).addClass('active');
        var id = $(this).data('project');

        $.ajax({
            url: "/ajax/get-project-details/" + id,
            method: 'get',
            data: {
                'lang': $('meta[name="app-lang"]').attr('content')
            },
            success: function (data) {
                $('.description').html(data).show();
            }
        });
    });

    //Buttons do not have an accessible name -- this to improve speed of website
    $(".owl-carousel .owl-dots .owl-dot").attr('aria-label','owl-dot');
    $(".owl-carousel .owl-nav .owl-prev").attr('aria-label','owl-prev');
    $(".owl-carousel .owl-nav .owl-next").attr('aria-label','owl-next');

    
    // to just hide modal when click prev button in browser
    $('.modal').on('shown.bs.modal', function () {
        var urlReplace = '#' + $(this).attr('id')
        history.pushState(null, null, urlReplace)
    })

    $(window).on('popstate', function () {
        $('.modal').modal('hide')
    });

    // Focus on search input when click on search icon
    let searchInput = $('#webAutoComplete');

    $('#modal-search').on('shown.bs.modal', function() {
        setTimeout(function(){
            $(searchInput).focus();
        },0);
    });


    $('[data-toggle="tooltip"]').tooltip()

});

$(document).on('click','.close-modal', function () {
    $('.project-modal').removeClass('active');
    $('.description').hide();
});
